import React, { useEffect, useState } from "react";
import BlogCardsRow from "../components/BlogCardsRow";
import HeroImageSection from "../components/HeroImageSection";
import solarservices from "../assets/solarservice.jpeg";
import { Helmet } from "react-helmet-async";
import { fetchBlogsFromWp } from "../data/wpApi";

// PROTOTYPE: fetches from a local headless WordPress instance instead of
// the static src/data/BlogsData.jsx array, to test whether WP can back
// this exact page with no visual differences. See src/data/wpApi.js.
const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogsFromWp(solarservices)
      .then(setBlogs)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white">
<Helmet>
  {/* Primary SEO */}
  <title>
    Solar Energy Blogs & Guides | Savorka Solar
  </title>

  <meta
    name="description"
    content="Read expert blogs on solar panel installation, solar subsidy, PM Surya Ghar Yojana, rooftop solar systems, maintenance, and the latest solar industry trends with Savorka Solar."
  />

  <meta
    name="keywords"
    content="solar panel installation, solar subsidy, pm surya ghar yojana, Solar Energy"
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.savorka.in/blogs"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Solar Energy Blogs & Guides | Savorka Solar"
  />
  <meta
    property="og:description"
    content="Read expert blogs on solar panel installation, solar subsidy, PM Surya Ghar Yojana, rooftop solar systems, maintenance, and the latest solar industry trends."
  />
  <meta
    property="og:url"
    content="https://www.savorka.in/blogs"
  />
  <meta
    property="og:image"
    content="https://www.savorka.in/og-image.jpg"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />
  <meta
    name="twitter:title"
    content="Solar Energy Blogs & Guides | Savorka Solar"
  />
  <meta
    name="twitter:description"
    content="Expert blogs on solar panel installation, solar subsidy, rooftop solar systems and renewable energy."
  />
  <meta
    name="twitter:image"
    content="https://www.savorka.in/og-image.jpg"
  />

  {/* Blog Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Savorka Solar Blog",
      "url": "https://www.savorka.in/blogs",
      "description":
        "Read expert blogs on solar panel installation, solar subsidy, PM Surya Ghar Yojana, rooftop solar systems, maintenance and renewable energy.",
      "publisher": {
        "@type": "Organization",
        "name": "Savorka Solar",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.savorka.in/logo.png"
        }
      },
      "inLanguage": "en-IN"
    })}
  </script>
</Helmet>
      <HeroImageSection
        title="OUR BLOGS"
        heroImage={solarservices}
        altText="Savorka Solar blog"
      />

      <section className="px-5 py-12">
        {loading && (
          <p className="text-center text-[#7c8798]">Loading posts…</p>
        )}
        {error && (
          <p className="text-center text-red-600">
            Couldn’t load posts from WordPress: {error}
          </p>
        )}
        {!loading && !error && <BlogCardsRow blogs={blogs} />}
      </section>

    </div>
  );
};

export default BlogPage;
